module.exports = __webpack_public_path__ + "img/2.88b3f7b3.jpg";